'use client';

import { useState } from 'react';

interface TemplateFilterProps {
  onFilterChange: (filter: 'all' | 'collector' | 'debtor') => void;
}

export default function TemplateFilter({ onFilterChange }: TemplateFilterProps) {
  const [activeFilter, setActiveFilter] = useState<'all' | 'collector' | 'debtor'>('all');

  const filters = [
    { id: 'filter_all', value: 'all' as const, label: 'All Templates' },
    { id: 'filter_collector', value: 'collector' as const, label: 'For Collectors' },
    { id: 'filter_debtor', value: 'debtor' as const, label: 'For Debtors' },
  ];

  const handleFilterClick = (filter: 'all' | 'collector' | 'debtor') => {
    setActiveFilter(filter);
    onFilterChange(filter);
  };

  return (
    <div data-component-id="src/app/templates/components/TemplateFilter.tsx:24:4" data-component-path="src/app/templates/components/TemplateFilter.tsx" data-component-line="24" data-component-end-line="38" data-component-file="TemplateFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20items-center%20justify-center%20gap-4%20mb-12%22%7D" className="flex flex-wrap items-center justify-center gap-4 mb-12">
      {filters.map((filter) => (
        <button data-component-id="src/app/templates/components/TemplateFilter.tsx:26:8" data-component-path="src/app/templates/components/TemplateFilter.tsx" data-component-line="26" data-component-end-line="36" data-component-file="TemplateFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
          key={filter.id}
          onClick={() => handleFilterClick(filter.value)}
          className={`px-6 py-2 rounded-full glass border transition-all ${
            activeFilter === filter.value
              ? 'bg-primary text-primary-foreground border-primary'
              : 'border-border hover:bg-card'
          }`}
        >
          <span data-component-id="src/app/templates/components/TemplateFilter.tsx:35:10" data-component-path="src/app/templates/components/TemplateFilter.tsx" data-component-line="35" data-component-end-line="35" data-component-file="TemplateFilter.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-medium%22%7D" className="font-medium">{filter.label}</span>
        </button>
      ))}
    </div>
  );
}